module.exports = __webpack_public_path__ + "static/media/partial_theft.11b8155a.svg";